export type PayoutNotifications = {
  enabled: boolean;
  secret: string;
  url: string;
};

export type PayoutNotificationsForm = Pick<PayoutNotifications, "url">;

export const PROPERTY_PAYOUT_NOTIFICATIONS_SECRET =
  "payout-notifications-secret";
export const PROPERTY_PAYOUT_NOTIFICATIONS_STATUS =
  "payout-notifications-status";
